/*
*###############################################################################
*Module Name                   : DesignationMaster.js                          #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               : I Dinisuru Balasuriya                         #
*Date                          : Monday, August 30th 2021, 10:14:01 am         #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import React, { useState, useEffect } from 'react'
import { MetaTags } from 'react-meta-tags'
import {
    Card,
    Col,
    Container,
    Row,
    CardBody,
} from 'reactstrap'

//**Importing required componant files   */
import Breadcrumb from 'components/Common/Breadcrumb'
import DPTopToolBar from 'framework/widgets/DPTopToolBar'
import TextContent from './TextContent'
import DPInfoBox from 'framework/layout/DPInfoBox'
import { Text } from "../../../framework/validators/TextValidation"
import DPAlert from "../../../framework/widgets/DPAlert"
import DPLoadingAlert from 'framework/widgets/DPLoadingAlert'
import DPPermission from 'framework/widgets/DPPermission'
import * as XLSX from "xlsx";
import DPPrintOption from 'framework/widgets/DPPrintOptions'
//**End Importing required componant files */
import { Context } from '../../../app-contexts/CommonContexts';
import { useHistory } from 'react-router-dom';
import { useContext } from 'react'
import { DeleteTextDetails, SaveTextDetails, TextGetData } from './TextController'

const TextFile = (props) => {
    const [newMenu] = useState(localStorage.getItem(window.location.pathname))
    let history = useHistory();
    //*** User input related states */
    const [GroupCode, SetCode] = useState("");// Set Code
    const [GroupDesc, SetDescription] = useState("")//Set Description
    const [IsActive, SetActive] = useState(true)//Set Active state
    const [menuCode, SetMenuCode] = useState("")
    const [groups, SetGroups] = useState([])
    const [change, SetChange] = useState(false)
    //*** End User input related states */

    //*** User Activity related states*/
    const [show, setShow] = useState(false)
    const [AlertMsg, setAlertMsg] = useState('')
    const [AlertColor, setAlertColor] = useState('')
    const [modal_xlarge, setmodal_xlarge] = useState(false)
    const [disabled, setDisabled] = useState(false)
    const [disabledCode, setDisabledCode] = useState(false)
    const [saveEnable, setSaveEnable] = useState(true)
    const [crEnable, setCrEnable] = useState(false)
    const [crBy, setCrBy] = useState("")
    const [mdBy, setMdBy] = useState("")
    const [crDate, setCrDate] = useState("")
    const [mdDate, setMdDate] = useState("")
    const [deleteEnable, SetDeleteEnable] = useState(false)
    const [Reason, setReason] = useState("Created")
    const [editEnable, SetEditEnable] = useState(false)
    //*** End User activity related staes */

    //Alert Parameters
    const [sweetAlertShow, setsweetAlertShow] = useState(false)
    const [AlertDescription, setAlertDescription] = useState(false)
    const [AlertConfirmOption, setAlertConfirmOption] = useState(0)
    const [ErrorMsg, setErrorMsg] = useState('')
    const [addNew, SetAddNew] = useState(true)
    //*** Get and Set values when user search code */

    //*****Menu Rights Start*/
    const [menuAccess, SetMenuAccess] = useState(false)
    const [menuCreate, SetMenuCreate] = useState(false)
    const [menuDelete, SetMenuDelete] = useState(false)
    const [menuModify, SetMenuModify] = useState(false)
    const [menuPrint, SetMenuPrint] = useState(false)
    const [menuProcess, SetMenuProcess] = useState(false)
    const [menuName, SetMenuName] = useState("")
    const [parentName, SetParentName] = useState("")
    const [LocationCode, setLocationCode] = useState("")
    const [LogUserType, setLogUserType] = useState("")
    const [LogCompanyCode, setLogCompanyCode] = useState("")
    //*****Menu Rights End */

    /**********Loading Alert */
    const [loadingAlert, SetLoadingAlert] = useState(false)
    const [loadingAlertTitle, SetLoadingAlerttitle] = useState("")
    /**********End Loading Alert */

    //autocode generation related newly added code
    const [codeButton, setCodeButton] = useState(true)
    const [searchdisabled, setSearchdisabled] = useState(false)
    const [nullCode, setNullCode] = useState(false)
    const [autoCode, setAutoCode] = useState(false)

    //User Permission related usestates
    const [permissionAlertShow, setPermissionAlertShow] = useState(false)
    const [permissionAlertTitle, setPermissionAlertTitle] = useState("")
    const [permissionReasonShow, setPermissionReasonShow] = useState(false)
    const [permissionName, setPermissionName] = useState("")
    const [permissionPassword, setPermissionPassword] = useState("")
    const [permissionNameDisable, setPermissionNameDisable] = useState(false)
    const [printoptionShow, setprintoptionShow] = useState(false)

    const [valueUpload, setvalueUpload] = useState("")
    const [items, setItems] = useState([]);
    const [Excelitems, setExcelItems] = useState([]);
    const [helpUrl, setHelpUrl] = useState("")
    var time = process.env.REACT_APP_ALERTTIMEOUT
    //import from contexts
    const {
        isHeadOffice, getMenuDetails, masterAuditLog
    } = useContext(Context);
    //import from contexts

    //**Get File Details */
    useEffect(async () => {
        const authToken = localStorage.getItem("authToken")
        var obj = JSON.parse(localStorage.getItem("authUser"))
        var LogUserType = obj[2]
        var menuDetail = await getMenuDetails(window.location.pathname + window.location.search)
        var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');
        var parentname = menuDetail?.parentName
        SetParentName(parentname)
        var LocationCode = obj[3]
        var CompanyCode = obj[5]
        setLocationCode(LocationCode)
        setLogUserType(LogUserType)
        setLogCompanyCode(CompanyCode)
        const ApiURL = window.Links.ApiURL


        var requestOptions = {
            method: 'GET',
            headers: {
                "Authorization": `Bearer ${authToken}`
            },
            redirect: 'follow'
        };

        fetch(`${ApiURL}login/menu/${LogUserType}/${menu}`, requestOptions)
            .then(response => response.json())
            .then(result => {
                SetMenuAccess(result.data.strMenuAccessRight)
                SetMenuCreate(result.data.strMenuCreateRight)
                SetMenuDelete(result.data.strMenuDeleteRight)
                SetMenuModify(result.data.strMenuModifyRight)
                SetMenuPrint(result.data.strMenuPrintRight)
                SetMenuProcess(result.data.strMenuProcessRight)
                SetMenuName(result.data.strMenuName)
                SetMenuCode(result.data.strMenuTag)
                setPermissionReasonShow(result.data.strMenuReasonShow)
                setHelpUrl(result.data.helpUrl)
                fetch(`${ApiURL}common/autocode/${result.data.strMenuTag}`, {
                    method: "GET",
                    headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
                }).then(Response => Response.json())
                    .then(responseData => {

                        if (responseData.success == true) {
                            if (responseData.data.length == 0) {
                                setNullCode(true)
                            } else {

                                setAutoCode(responseData.data)
                            }
                        } else {
                            setNullCode(true)
                        }
                    })

            }).catch(error =>
                console.log('error', error)
            );

    }, [GroupCode])

    // AuditLog
    useEffect(async () => {
        var obj = JSON.parse(localStorage.getItem("authUser"))
        var LogUserType = obj[2]
        var LocationCode = obj[3]
        var CompanyCode = obj[5]
        var menuDetail = await getMenuDetails(window.location.pathname)
        var menu =
            menuDetail && menuDetail.menuTag
                ? menuDetail.menuTag
                : history.push("/dashboard")

        await masterAuditLog(menu, LogUserType, LocationCode, CompanyCode) //masterfile access log
    }, [])


    const readExcel = (file) => {
        const promise = new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsArrayBuffer(file);

            fileReader.onload = (e) => {
                const bufferArray = e.target.result;

                const wb = XLSX.read(bufferArray, { type: "buffer" });

                const wsname = wb.SheetNames[0];

                const ws = wb.Sheets[wsname];

                const data = XLSX.utils.sheet_to_json(ws);

                setExcelItems(data);
                resolve(data);
            };

            fileReader.onerror = (error) => {
                reject(error);
            };
        });

        promise.then((d) => {
            setItems(d);
        });
    };

    // function getData(searchData) {
    //     const authToken = localStorage.getItem("authToken")
    //     if (searchData != "") {
    //         SetLoadingAlert(true)
    //         SetLoadingAlerttitle("Fetching...")
    //         const ApiURL = window.Links.ApiURL
    //         fetch(`${ApiURL}common/getGroupdetails/${searchData}`, {
    //             method: "GET",
    //             headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` }
    //         }).then(Response => Response.json())
    //             .then(responseData => {
    //                 SetLoadingAlert(false)
    //                 if (responseData.success == true) {
    //                     SetGroups(responseData.data)
    //                     SetChange(currentvalue => { return !currentvalue })
    //                 } else if (responseData.success == false) {
    //                     if (nullCode == false) {
    //                         setAlertMsg("Sub Groups Code Not Found")
    //                         setAlertColor('danger')
    //                         setShow(true)
    //                         setDisabledCode(true)
    //                         setTimeout(() => {
    //                             SetCode("")
    //                             setShow(false)
    //                         }, time)
    //                     }
    //                 }
    //             })
    //     }
    // }
    // //*** End useEffect */




    async function getData(searchData) {

        if (searchData == "") return

        SetLoadingAlert(true)
        SetLoadingAlerttitle("Fetching...")

        const result = await TextGetData(searchData);

        SetLoadingAlert(false)

        if (result.success == true) {

            SetGroups(result.data.data)
            SetChange(currentvalue => { return !currentvalue })
        } else if (result.success == false) {
            if (nullCode == false) {
                setDisabledCode(true)
                displayAlertMessage('danger', "Sub Groups Code Not Found")
                SetCode("")
            }
        }
    }

    //*** End useEffect */

    // print Function
    async function handlePrint(option) {
        // const authToken = localStorage.getItem("authToken")
        // var option = option
        // console.log(option)
        // SetLoadingAlert(true)
        // SetLoadingAlerttitle("Generating Report...")

        // console.log("print")
        // const ReportURL = window.Links.ReportURL
        // await fetch(`${ReportURL}api/designation/report/${LogUserType}`, {
        //     method: "GET",
        //     headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` }
        // }).then(Response => Response.json())
        //     .then(responseData => {
        //         console.log(responseData)
        //         // console.log(option)
        //         if (responseData.success == true) {
        //             if (option == "PDF") {
        //                 {
        //                     const msg = responseData.msg
        //                     window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.pdf`)
        //                 }
        //             }
        //             if (option == "XCEL") {
        //                 {
        //                     const msg = responseData.msg
        //                     window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.xlsx`)
        //                 }
        //             }

        //         }
        //         SetLoadingAlert(false)
        //     })


        const authToken = localStorage.getItem("authToken")
        //set autogenerate code to as CODE just for display purpuse

        if (GroupCode == "") {
            displayAlertMessage('danger', "Please Select Group Code")
            return;
        }

        var groupcodes = []
        groups.map((item, index) => {
            if (item.check) {
                groupcodes.push({ "code": item.code })
            }
        })


        const ApiURL = window.Links.ApiURL
        const groupset = {
            "GroupCode": GroupCode,
            "GroupList": groupcodes,
        }

        //loading alert show
        SetLoadingAlert(true)
        if (addNew == true) {
            SetLoadingAlerttitle("Saving...")
        } else {
            SetLoadingAlerttitle("Updating...")
        }

        //*** save/update records */
        fetch(`${ApiURL}common/GenerateScallerItems`,
            {
                method: "POST",
                headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
                body: JSON.stringify(groupset)
            }
        ).then(Response => {
            if (Response.status == "200") {
                SetLoadingAlert(false)
                Response.json()
                    .then(responseData => {
                        if (responseData.success == true) {
                            const msg = responseData.msg
                            const Link = document.createElement('a');
                            Link.href = `./Barcodes/${msg}.txt`;
                            Link.setAttribute(
                                'download',
                                `ScallerCodes.txt`,
                            );
                            // Append To Html Link Element Page
                            document.body.appendChild(Link);
                            // Start Download
                            Link.click();
                            ClearItem()
                        } else if (responseData.success == false) {
                            displayAlertMessage('danger', "Something Went Wrong !")
                        }
                    }
                    )
            } else if (Response.status == "400") {
                SetLoadingAlert(false)
                Response.json()
                    .then(responseData => {
                        setErrorMsg(responseData.msg)
                    })
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "Error !")
            } else {
                SetLoadingAlert(false)
                ClearItem()
            }
        }).catch(error => {
            console.log(error.message)
        })

        //***save/update end */
    }

    function tog_xlarge() {
        setmodal_xlarge(!modal_xlarge)
        removeBodyCss()
    }

    //removebodyCss function
    function removeBodyCss() {
        document.body.classList.add("no_padding")
    }

    //save button function
    const handlesave = async (e) => {

        const authToken = localStorage.getItem("authToken")
        //set autogenerate code to as CODE just for display purpuse

        if (GroupCode == "") {
            displayAlertMessage('danger', "Please Select Group Code")
            return;
        }

        var groups = []
        groups.map((item, index) => {
            if (item.check) {
                groups.push(item.code)
            }
        })

        // const ApiURL = window.Links.ApiURL
        // const groupset = {
        //     "GroupCode": GroupCode,
        //     "GroupList": groups,
        // }

        // //loading alert show
        // SetLoadingAlert(true)
        // if (addNew == true) {
        //     SetLoadingAlerttitle("Saving...")
        // } else {
        //     SetLoadingAlerttitle("Updating...")
        // }

        // //*** save/update records */
        // fetch(`${ApiURL}common/GenerateScallerItems`,
        //     {
        //         method: "POST",
        //         headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
        //         body: JSON.stringify(groupset)
        //     }
        // ).then(Response => {
        //     if (Response.status == "200") {
        //         SetLoadingAlert(false)
        //         Response.json()
        //             .then(responseData => {
        //                 console.log(responseData)
        //                 if (responseData.data == "Record Already Exsist!") {
        //                     setAlertMsg(responseData.data)
        //                     setAlertColor('danger')
        //                     setShow(true)
        //                 } else if (responseData.data == "Code Already Exsist!") {
        //                     setAlertMsg(responseData.data)
        //                     setAlertColor('danger')
        //                     setShow(true)
        //                     setCodeButton(false)
        //                 } else {
        //                     setAlertMsg(responseData.data)
        //                     setAlertColor('success')
        //                     ClearItem()
        //                     setShow(true)
        //                 }
        //             }
        //             )
        //     } else if (Response.status == "400") {
        //         SetLoadingAlert(false)
        //         Response.json()
        //             .then(responseData => {
        //                 setErrorMsg(responseData.msg)
        //             })
        //         setDisabled(false)
        //         setDisabledCode(false)
        //         setAlertColor('danger')
        //         setAlertMsg("Error !")
        //         setShow(true)
        //     } else {
        //         SetLoadingAlert(false)
        //         ClearItem()
        //     }
        // }).catch(error => {
        //     console.log(error.message)
        // })

        // //***save/update end */


        const groupset = {
            "GroupCode": GroupCode,
            "GroupList": groups,
        }

        //loading alert show
        SetLoadingAlert(true)
        if (addNew == true) {
            SetLoadingAlerttitle("Saving...")
        } else {
            SetLoadingAlerttitle("Updating...")
        }

        //*** save/update records */
        const result = await SaveTextDetails(groupset);

        SetLoadingAlert(false)

        if (result.success) {
            displayAlertMessage("success", result.data)
            ClearItem()
        } else {
            displayAlertMessage("danger", result.data)
        }
    }


    //***save/update end */


    //*** Get user selected row details */
    const GetSelectRow = (e, row, isSelect, rowIndex) => {
        SetCode(row.GS_FILENO);
        SetDescription(row.GS_FILENAME);
        getData(row.GS_FILENO);
        setDisabled(true)
        setDisabledCode(true)
        setSaveEnable(false)
        setmodal_xlarge(!modal_xlarge);
        setCrEnable(true)
    }
    //*** End of getSelectedRow function */

    //edit button function    
    const handleEdit = e => {
        setDisabled(false)
        setDisabledCode(true)
        setSaveEnable(true)
        SetDeleteEnable(true)
        SetEditEnable(false)
    }

    //new button function
    const handleNew = e => {
        //e.preventDefault()
        ClearItem();
        setShow(false)
        setSaveEnable(true)
        setCrEnable(false)
    }

    //clear fields function    
    const ClearItem = () => {
        SetCode("")
        SetDescription("")
        SetActive(true)
        setDisabledCode(false)
        setDisabled(false)
        // setShow(false)
        setCrEnable(false)
        setErrorMsg('')
        SetAddNew(true)
        SetDeleteEnable(false)
        SetDeleteEnable(false)
        setNullCode(false)
        setSearchdisabled(false)
        SetEditEnable(false)
        setSaveEnable(true)
        setReason("Created")
        SetEditEnable(false)
        setSaveEnable(true)
        setPermissionName("")
        setPermissionPassword("")
        setPermissionNameDisable(false)
        setCodeButton(true)
        setExcelItems([])
        SetGroups([])
        SetChange(current => { return !current })
        setTimeout(() => {
            setExcelItems([])
        }, 1)
    }

    // //********Delete button function */
    // const handleDelete = () => {
    //     const authToken = localStorage.getItem("authToken")
    //     const ApiURL = window.Links.ApiURL

    //     const rowDelete = {
    //         "strMenuCode": menuCode,
    //         "strCode": GroupCode,
    //         "strLoggedCompany": LogCompanyCode,
    //         "strLoggedLocation": LocationCode,
    //         "strReason": Reason,
    //         "strCreateBy": LogUserType
    //     }

    //     //loading alert show
    //     SetLoadingAlert(true)
    //     SetLoadingAlerttitle("Deleting...")

    //     fetch(`${ApiURL}Common/Delete`,
    //         {
    //             method: "POST",
    //             headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
    //             body: JSON.stringify(rowDelete)
    //         }
    //     ).then(Response => {
    //         if (Response.status == "200") {
    //             SetLoadingAlert(false)
    //             Response.json()
    //                 .then(responseData => {
    //                     console.log(responseData)
    //                     if (responseData.data == "Cannot Delete, Record Already Used!") {
    //                         setAlertMsg(responseData.data)
    //                         setAlertColor('warning')
    //                         setShow(true)
    //                     } else {
    //                         ClearItem()
    //                         setShow(true)
    //                         setAlertMsg(responseData.data)
    //                         setAlertColor('success')
    //                     }
    //                 }
    //                 )
    //         } else if (Response.status == "400") {
    //             SetLoadingAlert(false)
    //             Response.json()
    //                 .then(responseData => {
    //                     setErrorMsg(responseData.msg)
    //                 })
    //             setDisabled(false)
    //             setDisabledCode(false)
    //             setAlertColor('danger')
    //             setAlertMsg("Error !")
    //             setShow(true)
    //         } else {
    //             SetLoadingAlert(false)
    //             ClearItem()
    //         }
    //     }).catch(error => {
    //         console.log(error.message)
    //     })

    //     setTimeout(() => {
    //         setShow(false)
    //     }, time)

    // }
    // //*********Delete button function end */

    //********Delete button function */
    const handleDelete = async () => {

        const rowDelete = {
            "strMenuCode": menuCode,
            "strCode": GroupCode,
            "strLoggedCompany": LogCompanyCode,
            "strLoggedLocation": LocationCode,
            "strReason": Reason,
            "strCreateBy": LogUserType
        }

        //loading alert show
        SetLoadingAlert(true)
        SetLoadingAlerttitle("Deleting...")

        const result = await DeleteTextDetails(rowDelete);

        SetLoadingAlert(false)

        if (result.success) {
            displayAlertMessage("success", result.data)
            ClearItem()

        } else {

            displayAlertMessage("danger", result.data)
        }
    }

    //*********Delete button function end */



    //CODE AUTO GEN
    const AutoGenerateCode = async () => {
        const authToken = localStorage.getItem("authToken")
        const ApiURL = window.Links.ApiURL
        await fetch(`${ApiURL}common/autocode/${menuCode}`, {
            method: "GET",
            headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
        }).then(Response => Response.json())
            .then(responseData => {
                if (responseData.success == true) {
                    if (responseData.data.length > 0) {
                        SetCode(responseData.data)
                    } else {
                        setDisabledCode(false)
                    }
                }
            })
    }


    //**Permission Check */
    const permission = (operation) => {
        const authToken = localStorage.getItem("authToken")
        const ApiURL = window.Links.ApiURL
        const permissiondata = {
            strUsername: permissionName,
            strPassword: permissionPassword,
            strLocation: LocationCode,
            strMenuCode: menuCode
        }

        clearPermissionInputs()

        fetch(`${ApiURL}login/userpermission`,
            {
                method: "POST",
                headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
                body: JSON.stringify(permissiondata)
            }
        ).then(Response => {
            if (Response.status == "200") {
                Response.json()
                    .then(responseData => {

                        let Access = (responseData.data.strMenuAccessRight)
                        let Create = (responseData.data.strMenuCreateRight)
                        let Delete = (responseData.data.strMenuDeleteRight)
                        let Modify = (responseData.data.strMenuModifyRight)
                        let Print = (responseData.data.strMenuPrintRight)
                        let Process = (responseData.data.strMenuProcessRight)

                        if (operation == "Save") {
                            if (Create == true) {
                                handlesave()
                            } else if (Modify == true) {
                                handlesave()
                            } else {
                                if (operation == "Save" && addNew == true) {
                                    displayAlertMessage('danger', "This user dosen't have permission to save")
                                } else {
                                    displayAlertMessage('danger', "This user dosen't have permission to edit")
                                }
                            }
                        } else if (operation == "Delete") {
                            if (Delete == true) {
                                handleDelete()
                            } else {
                                displayAlertMessage('danger', "This user don't have permission to delete !")
                            }
                        } else if (operation == "Print") {
                            if (Print == true) {
                                setprintoptionShow(true)
                            } else {
                                displayAlertMessage('danger', "This user don't have permission to print !")
                            }
                        }
                    }
                    )

            } else if (Response.status == "400") {
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "Oops something went wrong !")
                clearPermissionInputs()

            } else if (Response.status == "403") {
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "You have not Permission to make changes !")
                clearPermissionInputs()

            } else if (Response.status == "404") {
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "Password or User Name is Invalid !")
                clearPermissionInputs()
            } else {
                ClearItem()
            }
        }).catch(error => {
            console.log(error.message)
        })
    }

    // Function for displaying Alert Messages.
    function displayAlertMessage(color, message) {
        setAlertColor(color)
        setAlertMsg(message)
        setShow(true)

        setTimeout(() => {
            setShow(false)
        }, time)
    }


    //handle permission alert
    function handlePermissionAlert(LogUserType, reason, disable, alertShow) {
        setPermissionName(LogUserType)
        setReason(reason)
        setPermissionNameDisable(disable)
        setPermissionAlertShow(alertShow)
    }


    //Clear permission name & password
    function clearPermissionInputs() {
        setPermissionName("");
        setPermissionPassword("");
        setReason("");
    }
    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>{menuName}</title>
                </MetaTags>
                <Container fluid={true}>
                    <Breadcrumb title={parentName} breadcrumbItem={menuName}></Breadcrumb>
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody>
                                    <DPAlert
                                        confirm_both={sweetAlertShow}
                                        title={menuName}
                                        description={AlertDescription}
                                        showCancel={true}
                                        btnColor={"success"}
                                        cancelColor={"danger"}
                                        onConfirm={() => {
                                            setsweetAlertShow(false)
                                            if (AlertConfirmOption == 1) {

                                                if (addNew == true && menuCreate == true && permissionReasonShow == false) {
                                                    handlesave()
                                                } else if (addNew == true && menuCreate == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Created", true, true)
                                                } else if (addNew == false && menuModify == true && permissionReasonShow == false) {
                                                    handlesave()
                                                } else if (addNew == false && menuModify == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Updated", true, true)
                                                } else {
                                                    setPermissionReasonShow(true)
                                                    setPermissionAlertShow(true)
                                                }

                                            } else if (AlertConfirmOption == 2) {
                                                handleEdit()
                                            } else if (AlertConfirmOption == 3) {
                                                history.push('/dashboard')
                                            } else if (AlertConfirmOption == 4) {
                                                handleNew()
                                            } else if (AlertConfirmOption == 6) {
                                                if (menuPrint == true && permissionReasonShow == false) {
                                                    setprintoptionShow(true)
                                                } else if (menuPrint == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Printed", true, true)
                                                } else {
                                                    setPermissionReasonShow(true)
                                                    setPermissionAlertShow(true)
                                                }
                                            } else if (AlertConfirmOption == 5) {

                                                if (addNew == false && menuDelete == true && permissionReasonShow == false) {
                                                    handleDelete()
                                                } else if (addNew == false && menuDelete == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Deleted", true, true)
                                                } else {
                                                    setPermissionReasonShow(true)
                                                    setPermissionAlertShow(true)
                                                }
                                            }
                                        }}
                                        onCancel={() => {
                                            setsweetAlertShow(false)
                                        }}
                                    />
                                    <DPPrintOption
                                        confirm_both={printoptionShow}
                                        title={menuName}
                                        description={permissionAlertTitle}
                                        showReason={permissionReasonShow}
                                        nameDisable={permissionNameDisable}
                                        showCancel={true}
                                        cancelColor={"danger"}
                                        onConfirmpdf={() => {
                                            handlePrint("PDF")
                                            setprintoptionShow(false)
                                        }}
                                        onConfirmxcel={() => {
                                            handlePrint("XCEL")
                                            setprintoptionShow(false)
                                        }}
                                        onCancel={() => {
                                            setprintoptionShow(false)
                                        }}
                                    />
                                    <DPPermission
                                        confirm_both={permissionAlertShow}
                                        title={menuName}
                                        description={permissionAlertTitle}
                                        showReason={permissionReasonShow}
                                        nameDisable={permissionNameDisable}
                                        showCancel={true}
                                        btnColor={"success"}
                                        cancelColor={"danger"}
                                        AlName={permissionName}
                                        AlNameOnchange={e => {
                                            let val2 = Text(e.target, 50, true, false, "any", true)
                                            setPermissionName(val2)
                                        }}
                                        AlPassward={permissionPassword}
                                        AlPasswardOnchange={e => {
                                            let val2 = Text(e.target, 50, true, true, "any", true)
                                            setPermissionPassword(val2)
                                        }}
                                        AlReason={Reason}
                                        AlReasonOnchange={e => {
                                            let val2 = Text(e.target, 50, true, false, "any", true)
                                            setReason(val2)
                                        }}
                                        onConfirm={() => {
                                            setPermissionAlertShow(false)
                                            if (AlertConfirmOption == 1) {
                                                permission("Save")
                                            } else if (AlertConfirmOption == 5) {
                                                permission("Delete")
                                            } else if (AlertConfirmOption == 6) {
                                                permission("Print")
                                            }
                                        }}
                                        onCancel={() => {
                                            setPermissionAlertShow(false)
                                            clearPermissionInputs()
                                        }}
                                    />
                                    <DPLoadingAlert
                                        confirm_both={loadingAlert}
                                        title={loadingAlertTitle}
                                    />
                                    <DPTopToolBar
                                        //Help Button
                                        helpEnable={helpUrl != "" ? true : false}
                                        helpClick={() => {
                                            window.open(helpUrl)
                                        }}
                                        //Favorite Button
                                        favoriteEnable={false}
                                        favoriteClick={() => {
                                            alert("Favorite")
                                        }}
                                        //New Button
                                        newEnable={true}
                                        newClick={() => {
                                            setAlertDescription("Do you wish to refresh the screen ?");
                                            setAlertConfirmOption(4)
                                            setsweetAlertShow(true)
                                        }}
                                        //Save Button
                                        saveEnable={saveEnable}
                                        saveClick={() => {
                                            setAlertDescription("Do you wish to save ?");
                                            setAlertConfirmOption(1)
                                            setsweetAlertShow(true)
                                        }}
                                        //ProcessButton
                                        processEnable={false}
                                        processClick={() => {
                                            alert("Process")
                                        }}
                                        //Edit Button
                                        editEnable={editEnable}
                                        editClick={() => {
                                            setAlertDescription("Do you wish to edit ?");
                                            setAlertConfirmOption(2)
                                            setsweetAlertShow(true)
                                        }}
                                        //Print Button
                                        printEnable={true}
                                        printClick={() => {
                                            setReason("Printed")
                                            setAlertDescription("Do you wish to print ?");
                                            setAlertConfirmOption(6)
                                            setsweetAlertShow(true)
                                        }}
                                        //Delete Button
                                        deleteEnable={deleteEnable}
                                        deleteClick={() => {
                                            setReason("Deleted")
                                            setAlertDescription("Do you wish to delete ?");
                                            setAlertConfirmOption(5)
                                            setsweetAlertShow(true)
                                        }}
                                        //Exit Button
                                        exitEnable={true}
                                        exitClick={() => {
                                            setAlertDescription("Do you wish to exit ?");
                                            setAlertConfirmOption(3)
                                            setsweetAlertShow(true)
                                        }}
                                    />
                                    <Row>
                                        <TextContent
                                            GetSelectRow={GetSelectRow}
                                            CodeValue={GroupCode}
                                            CodeonChange={e => {
                                                let val1 = Text(
                                                    e.target,
                                                    5,
                                                    true,
                                                    false,
                                                    "upper",
                                                    false
                                                )
                                                SetCode(val1)
                                            }}
                                            DescValue={GroupDesc}
                                            DescOnChange={e => {
                                                let val2 = Text(
                                                    e.target,
                                                    50,
                                                    true,
                                                    false,
                                                    "any",
                                                    true
                                                )
                                                SetDescription(val2)
                                            }}
                                            ActiveSw={IsActive}
                                            SwonChange={() => {
                                                SetActive(!IsActive)
                                            }}
                                            modelTrigger={tog_xlarge}
                                            modelOpen={modal_xlarge}
                                            show={show}
                                            disabled={disabled}
                                            disabledCode={disabledCode}
                                            AlertColor={AlertColor}
                                            AlertMsg={AlertMsg}
                                            CodeOnBlur={e => {
                                                getData(e.target.value)
                                            }}
                                            ErrorMsg={ErrorMsg}
                                            menuName={menuName}
                                            onButtonClick={e => {
                                                AutoGenerateCode()
                                                setCodeButton(true)
                                            }}
                                            btnDisable={codeButton}
                                            SearchDisable={searchdisabled}
                                            showFileUpload={(e) => {
                                                const file = e.target.files[0];
                                                readExcel(file);
                                                setvalueUpload(e.target.value)
                                            }}
                                            valueUpload={valueUpload}
                                            menuCode={menuCode}
                                            groups={groups}
                                            SetGroups={SetGroups}
                                            change={change}
                                        />
                                    </Row>
                                    <Row>
                                        {crEnable ? (
                                            <DPInfoBox
                                                createdBy={crBy}
                                                createdOn={crDate != '1900-01-01T00:00:00' ? crDate : ''}
                                                modifiedBy={mdBy}
                                                modifiedOn={mdDate != '1900-01-01T00:00:00' ? mdDate : ''}
                                            />
                                        ) : null}
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

        </React.Fragment>
    )

}

export default TextFile